export const STATUS_INVOICE = {
  PAYED: 'PAYED',
  UNPAYED: 'UNPAYED'
}
